// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__w1XPP","label":"LabeledBox_label__2KoYS"};